const $ = require('jquery');

module.exports = class ContentTabsWithImage {
  constructor(id) {
    const $root = $(`#${id}`);
    $root.find('[data-slide-trigger]').on('click', e => {
      $root.find('[data-slide-trigger]')
        .removeClass('border-red border-blue border-green border-purple border-yellow content-tabs-with-image-tab-active')
        .addClass('border-transparent');

      const $trigger = $(e.currentTarget);

      $trigger.removeClass('border-transparent')
        .addClass($trigger.data('borderclass'))
        .addClass('content-tabs-with-image-tab-active');

      $root.find('[data-slide]')
        .css('display', 'none');
      $root.find(`[data-slide="${$trigger.data('slide-trigger')}"]`)
        .css('display', 'flex');
    });
  }
};